export default __webpack_public_path__ + "static/media/002a.712aa2d2.jpg";